import { render, staticRenderFns } from "./CreateGlobalAdminPage.vue?vue&type=template&id=4262816c&scoped=true"
import script from "./CreateGlobalAdminPage.vue?vue&type=script&lang=ts"
export * from "./CreateGlobalAdminPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4262816c",
  null
  
)

export default component.exports